/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
class TechnicalEvaluationTable {
  static initClass() {
    this.prototype._type = null;
    this.prototype._selector = null;
    this.prototype._selectedEvaluations = [];

    this.prototype._renderInitialsDropdown = _.template(`
<div class='f-dropdown dark-content fixed' id='avatar-<%= id %>' data-dropdown-content=''>
<div class='f-dropdown-content'>
<div class='avatar default'>
<div class='initials'>
<%= evaluator_initials %>
</div>
</div>
<div class='user-details'>
<div class='name'>
<%= evaluator_name %>
</div>
<div class='user-status <%= mark %>'>
<%= state_humanized %>
</div>
</div>
<% if (!_.isEmpty(note)) { %>
<div class='markdown'>
${I18n.t('note')}: <%= note %>
</div>
<% } %>
</div>
</div>
`);
  }

  _renderEvaluationActions(data) {
    if (!data.my_evaluation) { return ''; }
    return `
<div class='document-reviews-actions'>
<a class='button nano pt-green ${data.my_evaluation.action_link_klass}' ${!data.my_evaluation.action_enabled ? 'disabled' : undefined} rel='nofollow' data-method='${data.my_evaluation.action_http_method}' href='${data.my_evaluation.action_link}' data-disable-with=\"${I18n.t('submit_in_progress')}\">${data.my_evaluation.action_name}</a>
</div>
`;
  }

  _renderRowActions(data) {
    if (!data.download_link) { return ''; }
    return `
<div class='row-actions'>
<a class='button nano icon-btn pt-download pt-blue tip-top' data-tooltip href='${data.download_link}' title='${'Export'}'></a>
</div>
`;
  }

  _renderDocumentDetails(data, type) {
    return `
<div class='document-details'>
<label class='custom-checkbox'>
<input type='checkbox' name='selected_bids' id='selected_bids' value=${data.bid_id} class='bid-checkbox-${type}'>
<span class='checkbox'></span>
</label>
<div class='document-name'>
<a href='${data.evaluation_path}'>${data.bidder_company_name}</a>
</div>
<div class='data-list'>
<div class='data-item'>
<div class='data-value'>
${data.status_with_time}
</div>
</div>
</div>
${this._renderRowActions(data)}
${this._renderEvaluationActions(data)}
</div>
`;
  }

  _renderInitials(data) {
    let tmpStep = 0;

    return _.map(data.tender_evaluations, evaluation => {
      let stepClass = (() => {
        if (evaluation.step !== tmpStep) {
          tmpStep = evaluation.step;
          return 'first-in-step';
        } else {
          return '';
        }
      })();
      if (evaluation.step === data.current_evaluation_step) {
        stepClass = stepClass + ' current';
      }

      return `
<div class='data-value ${stepClass}' data-dropdown='avatar-${evaluation.id}' data-options='is_hover: true;' aria-expanded='false'>
<div class='avatar default ${evaluation.state} ${this._avatarColor(evaluation)}'>
<div class='initials'>
${evaluation.evaluator_initials}
</div>
</div>
${this._renderInitialsDropdown(evaluation)}
</div>
`;
    }).join('');
  }

  _avatarColor(evaluation) {
    if ((evaluation.state !== 'submitted') || !evaluation.mark) { return ''; }
    return evaluation.mark;
  }

  _renderFinalScore(data) {
    if (data.final_score) {
      return "<div class='data-item score'>" +
        `<div class='data-label colon'>${I18n.t('final_rating')}</div>` +
        `<div class='data-value ${data.final_score}'>${data.final_score}</div>` +
        "</div>";
    } else {
      return '';
    }
  }

  _renderDocumentReviews(data) {
    return `
<div class='document-reviews evaluator-avatars-list'>
<div class='data-list'>
<div class='data-item wrap'>
<div class='data-label wrap'>
<span>${I18n.t('v4.tender_evaluations.index.evaluations')}:</span>
</div>
<span>
${this._renderInitials(data)}
</span>
<div class='data-label nowrap'>
${this._renderFinalScore(data)}
</div>
</div>
</div>
</div>
`;
  }

  _rowRenderer(params) {
    return this._renderDocumentDetails(params.data, this._type) + this._renderDocumentReviews(params.data);
  }

  _onSelectAllEvaluations(event) {
    $(`#${this._type}-evaluation-actions .dropdown-document-actions`).attr('disabled', !event.target.checked);
    $(`.bid-checkbox-${this._type}`).prop('checked', event.target.checked);
    return this._selectedEvaluations = $(`.bid-checkbox-${this._type}:checked`).map(function () { return $(this).val(); });
  }

  _onSelectSingleEvaluation(event) {
    $(`#${this._type}-evaluation-actions .dropdown-document-actions`).attr('disabled', $(`.bid-checkbox-${this._type}:checked`).length === 0);
    return this._selectedEvaluations = $(`.bid-checkbox-${this._type}:checked`).map(function () { return $(this).val(); });
  }

  _buildURLWithParams(href, params) {
    let separator = "?";
    if (href.indexOf('?') !== (-1)) { separator = "&"; }
    return `${href}${separator}${$.param(params)}`;
  }

  _onDownloadEvaluations(event) {
    event.preventDefault();
    const $target = $(event.currentTarget);
    const params = { selected_ids: this._selectedEvaluations.toArray().join() };
    return location.href = this._buildURLWithParams($target.attr('href'), params);
  }

  _setTableActions() {
    $(document).on('change', `#select-all-evaluations-${this._type}`, _.bind(this._onSelectAllEvaluations, this));
    $(document).on('change', `.bid-checkbox-${this._type}`, _.bind(this._onSelectSingleEvaluation, this));
    $(document).on('hover', '.download_evaluations', _.bind(this._onDownloadEvaluations, this));
    return $(document).on('click', `#${this._type}-actions-dropdown .download-evaluations`, _.bind(this._onDownloadEvaluations, this));
  }

  constructor(selector, data, type) {
    const columnDefs = [{
      cellRenderer: _.bind(this._rowRenderer, this),
      autoHeight: true
    }];
    this._type = type;
    this._selector = selector;

    const gridOptions = {
      headerHeight: 0,
      rowHeight: 115,
      domLayout: 'autoHeight',
      suppressRowTransform: true,
      rowData: null,
      defaultColDef: {
        resizable: true
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };

    gridOptions.columnDefs = columnDefs;
    gridOptions.rowData = data;
    const gridDiv = document.querySelector(selector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;
    resizeAgGridTable(selector, gridOptions);
    gridApi.sizeColumnsToFit();
    this._setTableActions();

    this._gridOptions = gridOptions;
  }
}
TechnicalEvaluationTable.initClass();

module.exports = TechnicalEvaluationTable;
